import { Link, useParams } from "react-router-dom";
import Project from "../../components/customer/Project";
import TableBody from "../../components/TableBody";
import { useEffect, useState } from "react";

// Skeleton компонент для строки проекта
const ProjectRowSkeleton = () => (
  <div className="grid grid-cols-3 gap-4 items-center border-b py-2 animate-pulse">
    <div className="h-4 bg-gray-300 rounded w-20"></div>
    <div className="h-4 bg-gray-300 rounded w-20"></div>
    <div className="h-8 bg-gray-300 rounded w-16"></div>
  </div>
);

function Customers() {
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(true);

  const params = useParams();

  useEffect(() => {
    async function fetchf() {
      setLoading(true);
      try {
        const res = await fetch(
          "https://time-api.web-hub.online/api/project?id=" + params.project
        );
        const data = await res.json();
        console.log("Notion block data:", data);

        setResult(data);
      } catch (error) {
        console.error("Error fetching project:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchf();
  }, [params.project]);

  return (
    <div className="w-full max-w-[1280px]">
      <h1 className="mb-6 text-3xl font-bold flex items-center gap-2">
        <svg
          width="23"
          height="20"
          viewBox="0 0 23 20"
          fill="none"
          className="w-8 h-6"
        >
          <path
            d="M1 6.20182V14.5011C1 15.6943 1.47838 16.8386 2.32989 17.6823C3.18141 18.526 4.33631 19 5.54054 19H17.4595C18.6637 19 19.8186 18.526 20.6701 17.6823C21.5216 16.8386 22 15.6943 22 14.5011V8.10147C22 6.9083 21.5216 5.76399 20.6701 4.92029C19.8186 4.07659 18.6637 3.6026 17.4595 3.6026H11.5M1 6.20182V4.37416C1 3.47927 1.35878 2.62104 1.99742 1.98827C2.63606 1.35549 3.50224 1 4.40541 1H7.6973C8.06999 0.999931 8.43905 1.0726 8.7834 1.21386C9.12775 1.35513 9.44065 1.56221 9.70422 1.82329L11.5 3.60372L9.70876 5.37853C9.44519 5.63961 9.13229 5.8467 8.78794 5.98796C8.44359 6.12922 8.07453 6.20189 7.70184 6.20182H1Z"
            stroke="#5489DA"
            strokeWidth="2"
          />
        </svg>

        <span className="uppercase">{result?.properties?.Name?.title[0]?.text?.content}</span>
      </h1>
      <TableBody
        className="grid-cols-3"
        header={
          <>
            <div>Available Time</div>
            <div>Total spent</div>
            <div>History</div>
          </>
        }
      >
        {loading ? (
          // Skeleton loader
          <ProjectRowSkeleton />
        ) : (
          // Реальные данные
          <Project item={result} />
        )}
      </TableBody>
    </div>
  );
}

export default Customers;
